<template>
	<div>
		<v-layout justify-space-between align-start wrap>
			<v-flex xs12 md6 lg3 class="mb-3">
				<v-select
					v-model="chosenCompanies"
					:items="companies"
					item-text="name"
					item-value="id"
					outlined
					dense
					chips
					small-chips
					label="בחר מרכז"
					multiple
				></v-select>
			</v-flex>
			<v-flex xs12 md6 lg3 class="mb-3">
				<v-menu
					ref="menu"
					v-model="menu"
					:close-on-content-click="false"
					:return-value.sync="chosenDates"
					transition="scale-transition"
					offset-y
					min-width="290px"
				>
					<template v-slot:activator="{ on }">
						<v-text-field
							v-model="dateRangeText"
							label="בחר תווך תאריכים"
							prepend-icon="event"
							readonly
							v-on="on"
						></v-text-field>
					</template>
					<v-date-picker v-model="chosenDates" range no-title scrollable>
						<v-spacer></v-spacer>
						<v-btn text color="primary" @click="menu = false">Cancel</v-btn>
						<v-btn text color="primary" @click="$refs.menu.save(chosenDates)">OK</v-btn>
					</v-date-picker>
				</v-menu>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import {types as companyTypes} from "src/store/modules/Company.module";
	import moment from "moment";


	export default {
		components: {},
		name: "table-filter",
		data() {
			return {
				chosenCompanies: [],
				chosenDates: [moment().subtract(1, "y").format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
				menu: false,
			};
		},
		computed: {
			companies() {
				return this.$store.state.CompanyModule.companies;
			},
			dateRangeText() {
				return this.chosenDates.join(" ~  ");
			},
		},
		watch: {
			chosenCompanies(newValue) {
				this.$emit("chosen-companies", newValue);
			},
			chosenDates(newValue) {
				this.$emit("chosen-dates", newValue);
			}
		},
		created() {
			this.$store.dispatch(companyTypes.FETCH);
		}
	};
</script>